module.exports = __webpack_public_path__ + "img/mobile_map_bologna.54c40525.svg";